module.exports = __webpack_public_path__ + "static/media/29915518936_8c876979ac_o.c82cdc37.jpg";